import { chat } from "@/lib/http";
import type { Space, SpaceAdmin, SpaceMember } from "./types";
import type { EntityPermissions } from "@/modules/conversation/types";

export function listSpaces(accountId: string) {
  return chat<Space[]>(`/v1/chat/accounts/${accountId}/spaces`);
}

export function getSpace(spaceId: string) {
  return chat<Space>(`/v1/chat/spaces/${spaceId}`);
}

export function createSpace(
  accountId: string,
  data: { title: string; visibility?: "public" | "restricted"; member_ids?: string[] },
) {
  return chat<Space>(`/v1/chat/accounts/${accountId}/spaces`, {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export function updateSpace(
  spaceId: string,
  data: { title?: string; visibility?: "public" | "restricted"; permissions?: EntityPermissions | null },
) {
  return chat<Space>(`/v1/chat/spaces/${spaceId}`, {
    method: "PATCH",
    body: JSON.stringify(data),
  });
}

export function deleteSpace(spaceId: string) {
  return chat<void>(`/v1/chat/spaces/${spaceId}`, { method: "DELETE" });
}

export function listSpaceMembers(spaceId: string) {
  return chat<SpaceMember[]>(`/v1/chat/spaces/${spaceId}/members`);
}

export function addSpaceMembers(
  spaceId: string,
  data: { member_ids: string[]; role?: string },
) {
  return chat<SpaceMember[]>(`/v1/chat/spaces/${spaceId}/members`, {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export function updateSpaceMemberRole(spaceId: string, userId: string, role: string) {
  return chat<SpaceMember>(`/v1/chat/spaces/${spaceId}/members/${userId}`, {
    method: "PATCH",
    body: JSON.stringify({ role }),
  });
}

export function removeSpaceMember(spaceId: string, userId: string) {
  return chat<void>(`/v1/chat/spaces/${spaceId}/members/${userId}`, {
    method: "DELETE",
  });
}

export function listSpaceAdmins(spaceId: string) {
  return chat<SpaceAdmin[]>(`/v1/chat/spaces/${spaceId}/admins`);
}

export function addSpaceAdmin(
  spaceId: string,
  userId: string,
  permissions?: Record<string, unknown> | null,
) {
  return chat<SpaceAdmin>(`/v1/chat/spaces/${spaceId}/admins`, {
    method: "POST",
    body: JSON.stringify({ user_id: userId, permissions: permissions ?? null }),
  });
}

export function removeSpaceAdmin(spaceId: string, userId: string) {
  return chat<void>(`/v1/chat/spaces/${spaceId}/admins/${userId}`, {
    method: "DELETE",
  });
}
